import Notifications from '../../../ui/molecules/toast/Notifications';

const customNotifications = (
  requestName: string,
  responseCode: string | number
) => {
  return Notifications(
    `${requestName} ended with ${responseCode}. Please try again later after some time`,
    0
  );
};

export default customNotifications;
